import { WritableDraft, current, produce } from 'immer'

import {
  extract_author,
  extract_end,
  extract_log,
  extract_message,
  extract_prompts,
  extract_sources,
} from './stream.handler'

import { Message, MessageType } from '../../../common/ai.dictionary'
import { AiState } from '../../ai.state'

export const onGetAnswerEventStreamOld = (
  state: AiState,
  { response }: { response: any }
): AiState =>
  produce(state, (draft: AiState) => {
    draft.streamingAiResponse = true
    draft.pendingRouteToAssistant = null
    const { message, context, sources } = response
    const lastMessageDraft = draft.messages[draft.messages.length - 1]
    const isLastMessageOfTypeAi = lastMessageDraft.type === MessageType.AiMsg
    if (isLastMessageOfTypeAi) {
      Object.assign(lastMessageDraft, response)
      lastMessageDraft.message = message
      lastMessageDraft.context = lastMessageDraft.context || context
      lastMessageDraft.sources = sources
      lastMessageDraft.type = MessageType.AiMsg
    } else {
      draft.messages.push({
        ...response,
        message,
        context,
        sources,
        type: MessageType.AiMsg,
      })
    }
  })

export const onGetAnswerEventStream = (state: AiState, { response }: { response: any }): AiState =>
  produce(state, (draft: AiState) => {
    if (!current(draft).backgroundAiResponse) {
      draft.streamingAiResponse = true
      draft.pendingAiResponse = true
    }
    draft.pendingRouteToAssistant = null
    const { message } = response
    const lastMessageDraft = draft.messages[draft.messages.length - 1]
    const answer = extract_message(message)
    const end = extract_end(message)
    const log = extract_log(message)
    const author = extract_author(message)
    // parse logs and register
    if (log) {
      draft.logs.unshift({
        agent: log.agent,
        message: log.debug.info,
        message_type: 'INFO',
        timestamp: log.timestamp,
        status: log.debug.status,
        step: log.debug.step,
      })
      draft.currentAITaskMessage = log.debug.info
      return
    }
    if ((message as any).answer) {
      parseAnswerMessage(draft, message)
    }
    if (end) {
      parseEndMessage(draft, message)
      return
    }
    if (!answer) {
      return
    }
    const isLastMessageOfTypeAi =
      lastMessageDraft &&
      lastMessageDraft?.type === MessageType.AiMsg &&
      !lastMessageDraft?.commited
    if (isLastMessageOfTypeAi) {
      lastMessageDraft.message = answer
      lastMessageDraft.author = author
      lastMessageDraft.html_preview = null
      lastMessageDraft.type = MessageType.AiMsg
    } else {
      draft.messages.push({
        ...response,
        message,
        type: MessageType.AiMsg,
      })
    }
  })

function parseAnswerMessage(draft: AiState, messagePayload): void {
  const lastMessageDraft = draft.messages[draft.messages.length - 1]
  const isLastMessageOfTypeAi =
    lastMessageDraft && lastMessageDraft?.type === MessageType.AiMsg && !lastMessageDraft?.commited
  if (isLastMessageOfTypeAi) {
    const sources = extract_sources(messagePayload)
    const prompts = extract_prompts(messagePayload)
    if (prompts) {
      lastMessageDraft.prompts = prompts
    }
    if (sources) {
      lastMessageDraft.sources = sources
    }
  }
}

function parseEndMessage(draft: AiState, message): void {
  const messagePayload = message.end

  if (messagePayload.operation === 'follow_up_questions') {
    draft.messages[draft.messages.length - 1].commited = true
    draft.pendingRouteToAssistant = null
  }

  if (messagePayload.operation === 'initial_actions') {
    draft.messages[draft.messages.length - 1].commited = true
    draft.pendingRouteToAssistant = null
  }
}
